import { render, staticRenderFns } from "./PagosGeneral.vue?vue&type=template&id=6dc5d196&scoped=true&"
import script from "./PagosGeneral.vue?vue&type=script&lang=js&"
export * from "./PagosGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PagosGeneral.vue?vue&type=style&index=0&id=6dc5d196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc5d196",
  null
  
)

export default component.exports